module.exports = __webpack_public_path__ + "static/media/skills.7f2f6033.svg";